<p-confirmDialog key="edit" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Form-->
<div class="MainGrid2Col">
	<label>Code:</label>
	<input [(ngModel)]="FineCD" class="form-control" type="text" placeholder="Code or Abbreviation" />

	<label>Description:</label>
	<input [(ngModel)]="FineDesc" class="form-control" type="text" placeholder="Name or Description" />

	<label>Defined By:</label>
	<label class="InfoText">{{ DefinedBy }}</label>

	<label>Default Fee:</label>
	<p-inputNumber [(ngModel)]="FineAmount" mode="currency" currency="USD" locale="en-US" step="0.01" [showButtons]="true"></p-inputNumber>
</div>

<!--Buttons-->
<div class="Buttons">
	<button class="btn btn-primary" (click)="onEdit()">Update</button>
	<button class="btn btn-primary" (click)="onClose()">Close</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
